export default __webpack_public_path__ + "static/media/y_m_nikhil_core.9367fe90.jpg";